import { ApiStatus, FETCH_METHODS, SearchConfig } from "./api.model";
import { BUTTON_NAMES, ListActions } from "./common.model";
import { DataTableSchema, DefaultTableSchema } from "./dynamic-data-table.model";
import { FirstNameText, LastNameText, FieldNames, defaultManageExceptionPaymentButtons, WorkDayNumber, EmailText, UserAccessScreensDropdown, DropdownOptions, UserAccessRolesDropdown } from "./form-fields.model";
import { ButtonFieldConfig, DynamicFormArray, FormFieldConfig, Props } from "./form.model";

export const updatedUserName = 'updatedUserName'
const FormFieldArray: FormFieldConfig[] = structuredClone([
    { ...structuredClone(WorkDayNumber), required: true },
    { ...structuredClone(EmailText), required: true, disabled: false, email: true },
    { ...structuredClone(FirstNameText), pattern: String.raw`^[a-zA-Z\s-]+$`, required: true, disabled: true },
    { ...structuredClone(LastNameText), pattern: String.raw`^[a-zA-Z\s-]+$`, required: true, disabled: true },
    { ...structuredClone(UserAccessRolesDropdown), required: true, disabled: true },
    { ...structuredClone(UserAccessScreensDropdown), disabled: true, defaultValue: [] }
]);

const FormButtonArray: ButtonFieldConfig[] = structuredClone(defaultManageExceptionPaymentButtons);

const getModuleOptions = () => {
    const mappings: any = {}
    DropdownOptions[FieldNames['UserAccessScreens']].forEach(option => {
        mappings[option['fieldValue']] = option['fieldLabel']
    })
    return mappings
}

export const Title = "Access Control";

export const UserDetailsListSearchConfig: SearchConfig = {
    path: 'getAccessControl',
    method: FETCH_METHODS['Post']
}
export const UserDetailsByWorkdaySearchConfig: SearchConfig = {
    path: 'getUserDetails',
    method: FETCH_METHODS['Get'],
    body: {
        workdayId: ''
    }
}
export const UserDetailsUpdateSearchConfig: SearchConfig = {
    path: 'addAccessControl',
    method: FETCH_METHODS['Post'],
    body: {
        [FieldNames['FirstName']]: "",
        [FieldNames['LastName']]: "",
        [FieldNames['WorkDayId']]: "",
        [FieldNames['Email']]: "",
        [FieldNames['UserAccessScreens']]: "",
        "updatedBy": ""
    }
}
export const UserDetailsDeleteSearchConfig: SearchConfig = {
    path: 'deleteAccessControl',
    method: FETCH_METHODS['Post'],
    body: {
        [FieldNames['WorkDayId']]: null
    }
}
export const EditActionButtons: ButtonFieldConfig[] = [
    { isDisabled: false, name: BUTTON_NAMES.Modify, isPrimary: true },
    { isDisabled: false, name: BUTTON_NAMES.Cancel }
]
export const UserRoleSettingsTitle = "Create New User";
export const UserRoleSettingsFormName = 'createUserForm';
export const UserRoleSettingsFilterSchema: DynamicFormArray = {
    FieldsArray: FormFieldArray,
    ButtonsArray: FormButtonArray,
    searchConfig: UserDetailsUpdateSearchConfig,
    title: UserRoleSettingsTitle,
    formName: UserRoleSettingsFormName,
    resetAfterSubmit: true,
    // Prevents the table's loading toggle from reverting the Workday/Email search-driven disabled state
    disableFieldsDuringLoad: false
}
export const EditActionFieldSchema: DynamicFormArray = {
    ...structuredClone(UserRoleSettingsFilterSchema),
    ButtonsArray: EditActionButtons,
    title: 'Modify Access',
    formName: 'editUserForm',
}
export const UserSettingsEditActionName = `${ListActions['edit']}_userRoles`
export const UserSettingsDeleteActionName = `${ListActions['delete']}_userRoles`

export const UserRoleSettingsTableSchema: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    columnSchema: [
        {
            label: 'Actions', fieldKey: 'CBL_userRole_actions', fieldType: 'Actions', actionConfig: [{
                fieldKey: UserSettingsEditActionName,
                iconClass: 'fa-solid fa-pen',
                toolTip: 'Edit'
            }, {
                fieldKey: UserSettingsDeleteActionName,
                iconClass: 'fa-solid fa-trash',
                toolTip: 'Delete'
            }, {
                fieldKey: '',
                iconClass: 'fa-solid fa-circle-info',
                toolTip: 'Info',
                isCustomToolTip: true
            }]
        },
        { label: 'First Name', fieldKey: FieldNames['FirstName'], isNotCamelCase: true },
        { label: 'Last Name', fieldKey: FieldNames['LastName'], isNotCamelCase: true },
        { label: 'Workday Id', fieldKey: FieldNames['WorkDayId'] },
        { label: 'User Role', fieldKey: FieldNames['Role'] },
        { label: 'Email', fieldKey: FieldNames['Email'], isNotCamelCase: true },
        {
            label: 'User Access Screens', fieldKey: FieldNames['UserAccessScreens'], isMultiSelect: true, fieldType: 'Array',
            options: DropdownOptions[FieldNames['UserAccessScreens']]
        },
    ],
    toolTip: [
        { name: 'Created By', value: 'createdByUser', isCamelPreserveTMNA: true },
        { name: 'Created On', value: "createdOn", isDate: true },
        { name: 'Updated By', value: "updatedByUser", isCamelPreserveTMNA: true },
        { name: 'Updated On', value: 'updatedOn', isDate: true }
    ],
    exportConfig: {
        fileName: 'Access_Control',
        isCamelCase: [FieldNames['FirstName'], FieldNames['LastName'], FieldNames['Role'], FieldNames['UserAccessScreens']],
        dropDownMapping: {
            [FieldNames['UserAccessScreens']]: getModuleOptions()
        },
        schema: {
            [FieldNames['FirstName']]: "First Name",
            [FieldNames['LastName']]: "Last Name",
            [FieldNames['WorkDayId']]: "Workday Id",
            [FieldNames['Role']]: "User Role",
            [FieldNames['Email']]: "Email",
            [FieldNames['UserAccessScreens']]: "User Access Screens"

        },
        exportMessage: 'Access Control Data'
    },
    isSearchRequired: true,
    isPaginationRequired: true,
    breadcrums: [{ level: 1, name: Title }]
}
export const UserRoleSettingsProps: Props = {
    isSearchVisible: true,
    isTabStretch: true
}

export type successFailureMsg = Record<ApiStatus, string>





